import { takeLatest } from 'typed-redux-saga';
import { workerErrorNotifyThunk } from 'utils/sagas';
import { actionReportGrossDeltaShekelFetch } from './actions';

export const sagasReportGrossDeltaShekel = [
  takeLatest(actionReportGrossDeltaShekelFetch.rejected, workerErrorNotifyThunk),
];
